jQuery(document).ready(function() {

    $('#recaptcha-token').each(function() {
        var $this = $(this)
        grecaptcha.ready(function() {
            grecaptcha.execute('6Lf9RQ4aAAAAAK0fh79hF8_vlzUYjxUYC2clrvw6', {action: 'homepage'}).then(function(token) {
                $this.val(token)
            })
        })
    })

});
